import moment from "moment";
import { FunctionComponent, useEffect, useState } from "react";
import LoadingWidget from "../../../../components/loading_spinner";
import { ComplaintFilterModle } from "..";
import {
  useToast,
  ToastType,
} from "../../../../../context_providers/toast/toast_ctx";
import { mdiDownload } from "@mdi/js";
import Icon from "@mdi/react";
import { toQueryString } from "../../../../../service/api_client";
import { offsetM, offsetMs } from "../../../../../utils/constant";
import { ExportComplaintsByEmail } from "../../../../../service/repos/support/complaint_repo";

interface ExportComplaintsProps {
  filter: ComplaintFilterModle;
}

const ExportComplaints: FunctionComponent<ExportComplaintsProps> = (props) => {
  const { showToast } = useToast();
  const [loading, setLoading] = useState(false);

  const [fromDate, setFromdate] = useState<Date>();
  const [toDate, setTodate] = useState<Date>();

  const getOrders = async () => {
    if (!fromDate || !toDate) {
      showToast({
        type: ToastType.error,
        text: "Please select date",
      });
      return;
    } else if (
      moment(fromDate, "YYYY-MM-DD").isAfter(moment(toDate, "YYYY-MM-DD"))
    ) {
      showToast({
        type: ToastType.error,
        text: "From date should not be greater than to date",
      });
      return;
    }

    setLoading(true);

    try {
      const queryParams = toQueryString({
        query: JSON.stringify({
          filterData: {
            ...props.filter.filterData,
            fromDate: fromDate as any,
            toDate: toDate as any,
          },
        }),
      });

      const response = await ExportComplaintsByEmail(queryParams);

      console.log("response", response);

      if (response.success) {
        showToast({
          type: ToastType.success,
          text: response.message,
        });
      } else {
        showToast({
          type: ToastType.error,
          text: response.message,
        });
      }

      setLoading(false);
    } catch (error: any) {
      console.error("Export initiation error:", error);

      showToast({ type: ToastType.error, text: error.error });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (props.filter.filterData?.fromDate && props.filter.filterData.toDate) {
      setFromdate(props.filter.filterData.fromDate);
      setTodate(props.filter.filterData.toDate);
    }
  });
  return (
    <div className="p-5">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        <div className="">
          <label htmlFor="complaints_export_from_date">From</label>
          <input
            id="complaints_export_from_date"
            className="border rounded p-2 w-full focus:outline-none outline-none"
            type="date"
            name="fromDate"
            placeholder="From"
            required
            value={
              fromDate &&
              moment(fromDate).utcOffset(offsetM).format("YYYY-MM-DD")
            }
            onChange={(e) => {
              let d = e.target.valueAsDate;
              d?.setUTCHours(0, 0, 0, 0);
              d = new Date(d!.getTime() - offsetMs);

              if (toDate && moment(d).isAfter(moment(toDate))) {
                showToast({
                  type: ToastType.error,
                  text: "From date should not be greater than todate",
                });
                return;
              }
              setFromdate(d);
            }}
          />
        </div>
        <div className="">
          <label htmlFor="complaints_export_to_date">To</label>
          <input
            id="complaints_export_to_date"
            className="border rounded p-2 w-full focus:outline-none outline-none"
            type="date"
            name="toDate"
            placeholder="To"
            required
            value={
              toDate && moment(toDate).utcOffset(offsetM).format("YYYY-MM-DD")
            }
            min={
              fromDate
                ? moment(fromDate).utcOffset(offsetM).format("YYYY-MM-DD")
                : ""
            }
            onChange={(e) => {
              let d = e.target.valueAsDate;
              d?.setUTCHours(23, 59, 59, 999);
              d = new Date(d!.getTime() - offsetMs);
              if (fromDate && moment(fromDate).isAfter(moment(d))) {
                showToast({
                  type: ToastType.error,
                  text: "To date should  be greater than From date",
                });
                return;
              }
              setTodate(d);
            }}
          />
        </div>
      </div>
      <div className="flex justify-end my-2">
        <button
          id="complaints_export_download_btn"
          onClick={getOrders}
          className="flex items-center gap-1 border rounded px-3 py-2"
        >
          <Icon path={mdiDownload} className="h-4 w-5"></Icon>
          <p>Download</p>
        </button>
      </div>
      <LoadingWidget loading={loading} />
    </div>
  );
};

export default ExportComplaints;
